module.exports = __webpack_public_path__ + "media/images/homepage-courmetten-67a45dd56ae39513f23257e486ae16a5.jpg";